module.exports = __webpack_public_path__ + "assets/jisuanqi.f2f68c92.svg";